import { Menu, MenuItem, IconButton} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";
import React from "react";
import InviteMemberDialog from "./InviteMemberDialog";

export default function DropdownButton({ boardId }: { boardId: string }) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [presentDialog, setPresentDialog] = useState(false);


    return (
        <>
            <IconButton aria-label="Board actions" aria-haspopup="menu" aria-expanded={Boolean(anchorEl)} onClick={(e) => setAnchorEl(e.currentTarget)}>
                <ArrowDropDownIcon />
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={() => {setAnchorEl(null); setPresentDialog(true);}}>Invite member</MenuItem>
            </Menu>

            <InviteMemberDialog
                boardId={boardId}
                open={presentDialog}
                onClose={() => setPresentDialog(false)}
            />
        </>
    );
}
